import maintenanceImg from '../../assets/images/illustration_Maintenance@1x.png'
import './maintenance.css'

export const Maintenance = () => {
    return (
        <div className="maintenance">
            <div className="title">Service Maintenance</div>
            <div className="txt">
                <p>We sincerely apologize for the incovenience. </p>
                <p>Our site is currently under maintenance and will return shortly. </p>
                <p>Please try again or Contact Us.</p>
            </div>
            <div style={{ textAlign: 'center' }}>
                <img src={maintenanceImg} alt="Service Maintenance" />
            </div>
        </div>
    )
}
